import { render, staticRenderFns } from "./EventSeatLayout.vue?vue&type=template&id=685aa886&scoped=true"
import script from "./EventSeatLayout.vue?vue&type=script&lang=js"
export * from "./EventSeatLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685aa886",
  null
  
)

export default component.exports